import { submissionLoadingScreens, submissionLoadingScreenInterval } from '@/config/submission-loading-screens.js';

export function createApplicationSettings(props) {
    return {
        country: props.country,
        portalBaseUrl: props.portalBaseUrl,
        mustRedirect: true,

        // bootstrap classes to change form/fields look
        formStyle: {
            buttonColor: {
                next: 'primary',
                skip: 'light',
            },
            inputColor: {
                radio: 'primary'
            }
        },

        // switch to toggle general validation
        shouldValidateForm: true,

        progressBar: {
            active: true,
            isFinalStep: false,
            step: 0,
            valueNow: 0,
            totalSteps: 0,
        },

        // user/member status
        isUserRegistered: false,
        isUserAuthenticated: false,
        isUserVerified: false,

        // authentication
        userSkippedAuthentication: false,
        userFailedAuthentication: false,
        userAuthenticationAttempts: 0,

        // registration
        userWantsRegistration: false,
        userSkippedRegistration: false,
        userFailedRegistration: false,

        // verification
        userWantsVerification: false,
        userSkippedVerification: false,
        userFailedVerification: false,

        // loading animation
        showLoadingAnimation: false,
        loadingAnimationSeconds: 0,
        showBrandLogoDuringAnimation: true,
        showAffiliateLogoDuringAnimation: false,
        loadingAnimationImage: null,
        loadingAnimationType: 'spinner',

        // rotating messages shown during final submission
        submissionLoadingScreens: submissionLoadingScreens,
        submissionLoadingScreenInterval: submissionLoadingScreenInterval,

        // notifications
        notifications: {
            success: {},
            error: {},
            warning: {},
        },
        //
        currentNotice: null,
        completedApplication: false,
        partialRequestOnEveryStep: false,
        // stepOnFirstUserClick:
        // -- keeps the step number on the one a user clicks for the first time
        // -- set with @click event in the form (LcForm).
        // -- null = user has not clicked yet (explicit sentinel). Do not use 0 because 0 is a valid step number.
        // -- needed to determine whether or not to show the "Continue your application..."
        // (showPrepopMessage) message when the Lead is coming from a prepop request (token is present)
        stepOnFirstUserClick: null,
    };
}

export function createFlowSettings() {
    return {
        initialFlowSettings: {
            isVisible: true,
            isCompleted: false,
        },
        registrationFlowSettings: {
            isVisible: false,
            isCompleted: false,
        },
        registrationFlowSettingsForMembers: {
            isVisible: false,
            isCompleted: false,
        },
        verificationFlowSettings: {
            isVisible: false,
            isCompleted: false,
        },
    };
}
